// extracted by mini-css-extract-plugin
module.exports = {"categoryHeaderName":"_1XjF4","categoryHeaderDescription":"cWWUT"};